import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import "jspdf-autotable";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";
import CreateRoleTable from "./CreateRoleTable";

const CreateRoleDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  setNoTimeSet,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
  }, [dataClient]);

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clintBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

  // const fetchDashboardData = async () => {
  //   try {
  //     const response = await fetch(
  //       `${FULL_API_BASE_URL}/get-roles?client_branch_id=${clintBranchId}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(
  //         "Failed to fetch dashboard data. Please check the API or authentication details."
  //       );
  //     }

  //     const result = await response.json();
  //     const tableData = result?.data || [];
  //     const rawHeaders = tableData[0] || [];
  //     const rows = tableData.slice(1) || [];

  //     const formattedHeaders = rawHeaders.map((header) =>
  //       String(header).replace(/^[a-zA-Z]\*/, "")
  //     );
  //     const transformedRows = rows.map((row) =>
  //       row.map((cell) => {
  //         if (cell === "" || cell === null || cell === undefined) {
  //           return "---";
  //         }
  //         return cell;
  //       })
  //     );

  //     setHeaders(formattedHeaders);
  //     setReportDashboardData(transformedRows);
  //   } catch (error) {
  //     console.error("Error fetching dashboard data:", error);
  //   }
  // };

  // const handleCancel = () => {
  //   window.location.reload();
  // };

  const fetchDashboardData = async () => {
    setNoTimeSet(true);
    setIsLoading(true);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>
            Loading data, please wait...
          </span>
        </div>
      </div>
    );
    setActiveImg(false);
    const slowLoadingTimer = setTimeout(() => {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              This is taking longer than usual, please wait a moment...
            </span>
          </div>
        </div>
      );
    }, 5000);

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-roles?client_branch_id=${clintBranchId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          "Failed to fetch dashboard data. Please check the API or authentication details."
        );
      }

      const result = await response.json();
      if (result.status === 200 && result.message === "Success") {
        const tableData = result?.data || [];
        const rawHeaders = tableData[0] || [];
        const rows = tableData.slice(1) || [];

        const formattedHeaders = rawHeaders.map((header) =>
          String(header).replace(/^[a-zA-Z]\*/, "")
        );
        const transformedRows = rows.map((row) =>
          row.map((cell) => {
            if (cell === "" || cell === null || cell === undefined) {
              return "---";
            }
            return cell;
          })
        );

        setHeaders(formattedHeaders);
        setReportDashboardData(transformedRows);
        clearTimeout(slowLoadingTimer);
        setIsLoading(false);
        setNoTimeSet(false);
        setIsMessageBoxVisible(false);
      } else {
        clearTimeout(slowLoadingTimer);
        setIsLoading(false);
        setNoTimeSet(false);
        setIsMessageBoxVisible(true);

        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                {result.message || "Failed to fetch data. Please try again."}
              </span>
            </div>
          </div>
        );
        console.error("API returned non-success response:", result);
      }
    } catch (error) {
      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(true);

      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              Error: {error.message}
            </span>
          </div>
        </div>
      );
      console.error("Error fetching dashboard data:", error);
    }
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "37px",
        marginBottom: "40px",
      }}
    >
      <div className="">
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 1001,
            top: 0,
          }}
        >
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>Role Dashboard</p>
          <div style={{ display: "flex" }}>
            {/* <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
              onClick={handleCancel}
            >
              CANCEL
            </button> */}
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                width: "160px",
                boxShadow: "0px 4px 4px 0px #00000040",
                backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
                cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
                color: selectedRows.length > 0 ? "#424342" : "",
              }}
              disabled={selectedRows.length === 0}
              onMouseEnter={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "#fa4741";
                  e.target.style.color = "white";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "#424342";
                }
              }}
              // onClick={() => { navigate(`/update_assign_user_to_role`); }}
              //  onClick={() => {
              //   if (selectedRows.length > 0) {
              //     const selectedRowData = reportDashboardData.find(
              //       row => row[0] === selectedRows[0]
              //     );
              //     const roleId = selectedRowData ? selectedRowData[0] : "";
              //     navigate(`/update_assign_user_to_role?MNTCreatedRoleID=${roleId}`);
              //   }
              // }}
              onClick={() => {
                if (selectedRows.length > 0) {
                  const selectedRowData = reportDashboardData.find(
                    (row) => row[0] === selectedRows[0]
                  );

                  if (!selectedRowData) return;

                  const roleId = selectedRowData[0];
                  const roleCode = selectedRowData[1];
                  const roleName = selectedRowData[2];
                  const roleDescription = selectedRowData[3];
                  const status = selectedRowData[5];

                  navigate(
                    `/update_assign_user_to_role?MNTCreatedRoleID=${roleId}` +
                      `&roleName=${encodeURIComponent(roleName)}` +
                      `&roleDescription=${encodeURIComponent(
                        roleDescription
                      )}` +
                      `&roleCode=${encodeURIComponent(roleCode)}` +
                      `&status=${encodeURIComponent(status)}`
                  );
                }
              }}
            >
              MANAGE USERS
            </button>
            <button
              className="create-test-section-btn"
              onClick={() => {
                navigate(`/new_create_role`);
              }}
            >
              NEW
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "0px 0px 1px 0px",
                }}
              >
                +
              </span>
            </button>
          </div>
        </div>
        <p style={{ marginTop: "10px", color: "#2F2E40" }}>
          Roles are listed here. Select a role code to view its details. Use
          Manage Access to add or remove users and groups. If a required role is
          missing, create it using the New button.
        </p>
        <div>
          <CreateRoleTable
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Roles..."
            dataClient={dataClient}
            setPagePath={setPagePath}
            renderQuestionText={renderQuestionText}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            bulk={false}
            setMessageBox={setMessageBox}
            setIsMessageBoxVisible={setIsMessageBoxVisible}
            setActiveImg={setActiveImg}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateRoleDashboard;
